import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCountries,
  fetchStates,
  fetchDistricts,
  fetchLocalAreas,
  fetchBusinessTypes,
  fetchBusinessCategories,
  fetchBusinessServices,
} from "./masterThunks";

const initialState = {
  countries: [],
  states: [],
  districts: [],
  localAreas: [],
  businessTypes: [],
  businessCategories: [],
  businessServices: [],
  loading: false,
  error: null,
};

// Common handlers
const pending = (state) => {
  state.loading = true;
  state.error = null;
};

const rejected = (state, action) => {
  state.loading = false;
  state.error = action.payload || "Something went wrong";
};

const masterSlice = createSlice({
  name: "master",
  initialState,
  reducers: {
    clearStates: (state) => {
      state.states = [];
      state.districts = [];
      state.localAreas = [];
    },
    clearDistricts: (state) => {
      state.districts = [];
      state.localAreas = [];
    },
    clearLocalAreas: (state) => {
      state.localAreas = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // COUNTRIES
      .addCase(fetchCountries.pending, pending)
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.loading = false;
        state.countries = action.payload;
      })
      .addCase(fetchCountries.rejected, rejected)

      // STATES
      .addCase(fetchStates.pending, pending)
      .addCase(fetchStates.fulfilled, (state, action) => {
        state.loading = false;
        state.states = action.payload;
      })
      .addCase(fetchStates.rejected, rejected)

      // DISTRICTS
      .addCase(fetchDistricts.pending, pending)
      .addCase(fetchDistricts.fulfilled, (state, action) => {
        state.loading = false;
        state.districts = action.payload;
      })
      .addCase(fetchDistricts.rejected, rejected)

      // LOCAL AREAS
      .addCase(fetchLocalAreas.pending, pending)
      .addCase(fetchLocalAreas.fulfilled, (state, action) => {
        state.loading = false;
        state.localAreas = action.payload;
      })
      .addCase(fetchLocalAreas.rejected, rejected)

      // BUSINESS TYPES
      .addCase(fetchBusinessTypes.pending, pending)
      .addCase(fetchBusinessTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.businessTypes = action.payload;
      })
      .addCase(fetchBusinessTypes.rejected, rejected)

      // BUSINESS CATEGORIES
      .addCase(fetchBusinessCategories.pending, pending)
      .addCase(fetchBusinessCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.businessCategories = action.payload;
      })
      .addCase(fetchBusinessCategories.rejected, rejected)

      // BUSINESS SERVICES
      .addCase(fetchBusinessServices.pending, pending)
      .addCase(fetchBusinessServices.fulfilled, (state, action) => {
        state.loading = false;
        state.businessServices = action.payload;
      })
      .addCase(fetchBusinessServices.rejected, rejected);
  },
});

export const { clearStates, clearDistricts, clearLocalAreas } = masterSlice.actions;
export default masterSlice.reducer;